import { fromJS, List, Map } from 'immutable';
// import { ProductRecord, PackageRecord } from './../Record/Products';
const NAME_SPACE = 'PC/';
const initialState = Map({
  'loading': true,
  'data': List([]),
  'pageSize': 0,
  'currentPage': 0,
  'count': 0,
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_PRODUCTS_COLLECTION':
      return fromJS(action.payload.products);
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', loading => action.payload.state);
    default:
      return state;
  }
};

const Products = (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_PRODUCTS_COLLECTION':
      return item(state, action);
    case NAME_SPACE + 'V_LOADING':
      return item(state, action);
    default:
      return state;
  }
};

export default Products;